var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChargeableIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.804 18.213V18.213C17.299 17.712 14.715 17.774 12.237 18.393L12 18.453C9.366 19.111 6.619 19.177 3.957 18.644L3.804 18.613C3.336 18.52 3 18.109 3 17.633V6.794C3 6.163 3.577 5.69 4.196 5.813V5.813C6.701 6.314 9.285 6.252 11.763 5.633L12.236 5.515C14.714 4.896 17.299 4.834 19.803 5.335L20.195 5.413C20.664 5.507 21 5.917 21 6.394V17.233C21 17.864 20.423 18.337 19.804 18.213V18.213Z",
    stroke: "#268EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.013C13.1046 14.013 14 13.1176 14 12.013C14 10.9084 13.1046 10.013 12 10.013C10.8954 10.013 10 10.9084 10 12.013C10 13.1176 10.8954 14.013 12 14.013Z",
    stroke: "#268EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChargeableIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ChargeableIcon.8acf22c0.svg";
export { ForwardRef as ReactComponent };